import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';

import ContactModal from '../../components/ContactModal';

function ContactTag({ agent }) {
  const phone = get(agent, 'telephone', '');

  return (
    <div className="position-fixed contact-tag">
      <ContactModal>
        <div className="d-flex align-items-center">
          <div>
            <img src={get(agent, 'logo.contentUrl')} alt="Online Sales Counselor" height="70" width="auto" />
          </div>
          <div className="pl-3">
            <span>Ask 70 West!</span><br />
            {phone.replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}
          </div>
        </div>
      </ContactModal>
    </div>
  );
}

ContactTag.propTypes = {
  agent: PropTypes.object.isRequired,
};

export default withData(
  {
    community: true,
    agent: true,
  },
  {
    required: {
      agent: true,
    },
  },
)(ContactTag);



// WEBPACK FOOTER //
// ./src/components/ContactTag/index.js